"use client";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  flagsCountForTemporeryBan: 0,
  temporeryBanCountForPermanentBan: 0,
  daysCountForTemporeryBan: 0,
};

const commonSlice = createSlice({
  name: "commonReducer",
  initialState,
  reducers: {
    setUpdatedBanCriteria: (state, action) => {
      const { flag, ban, duration } = action.payload;
      state.flagsCountForTemporeryBan = flag;
      state.temporeryBanCountForPermanentBan = ban;
      state.daysCountForTemporeryBan = duration;
    },
  },
});

export const { setUpdatedBanCriteria } = commonSlice.actions;

export default commonSlice.reducer;
